// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2239":"d63f83bbc2c608fc","14720":"e3ca36435cb7915e","15965":"589d8a59a4be3154"}[chunkId] + ".css";
};